import { JsonObject, JsonProperty } from 'json2typescript';

import { DateConverter } from '@shared/utils/date.converter';

import { DocumentItem } from './document.model';

@JsonObject('deceasedMoreInformations')
export class DeceasedMoreInformation {
  @JsonProperty('deceasedDate', DateConverter, true)
  public deceasedDate: Date | undefined = undefined;

  @JsonProperty('documents', [DocumentItem], true)
  public documents: DocumentItem[] = [];

  @JsonProperty('hasFuneralContract', String, true)
  public hasFuneralContract = '';
}
